import { render } from "./BarcodeScanTerms.vue?vue&type=template&id=c3084f78"
import script from "./BarcodeScanTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScanTerms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/barcodeScanTerms/BarcodeScanTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3084f78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3084f78', __exports__)) {
    console.log('reload')
    api.reload('c3084f78', __exports__)
  }
  
  module.hot.accept("./BarcodeScanTerms.vue?vue&type=template&id=c3084f78", () => {
    console.log('re-render')
    api.rerender('c3084f78', render)
  })

}


export default __exports__